import * as Yup from "yup";
import { ProjectValues } from "./ProjectForm/index.dto";
// import { t } from 'i18next';
import * as conf from "qpr-base/configuration";
import { KPIValues } from "./KPIsForm/index.dto";

const t = (s: string) => s;
export const PROJECT_EMPTY_INITIAL_VALUES: ProjectValues = {
  basicInformation: {},
  parentelementid: "",
  measureunitid: "",
  periodlevelid: "",
  valuesettingid: "",
  location: {
    topelementid: "",
    themesymbol: "",
    prioritysymbol: "",
  },

  scheduleAndBudget: {
    "Project End Date": "",
    "Project Start Date": "",
    budget: 0,
  },
  Milestones: [],
  projectValues: [],
};

export const Project_ValidationSchema = () => {
  let lang = conf.getLanguages();
  return Yup.object().shape({
    basicInformation: Yup.object().shape({
      [lang[0]]: Yup.object().shape({
        Name: Yup.string()
          .min(2, t("Too Short!"))
          .max(255, t("Too Long!"))
          .required(t("Required Field")),
      }),
    }),

    scheduleAndBudget: Yup.object().shape({
      "Project End Date": Yup.string().required(t("Required Field")).nullable(),
      "Project Start Date": Yup.string()
        .required(t("Required Field"))
        .nullable(),
      budget: Yup.number()
        .typeError(t("Invalid number"))
        .min(0, t("Budget can not be negative!")),
    }),
    parentelementid: Yup.string().required(t("Required Field")),
    measureunitid: Yup.string().required(t("Required Field")),
    periodlevelid: Yup.string().required(t("Required Field")),
  });
};

export const KPI_FORM_VALIDATION = () => {
  const lang = conf.getLanguages();
  return Yup.object().shape({
    basicInformation: Yup.object().shape({
      [lang[0]]: Yup.object().shape({
        Name: Yup.string()
          .min(2, t("Too Short!"))
          .max(255, t("Too Long!"))
          .required(t("Required Field")),
      }),
    }),
    measureunitid: Yup.string().required(t("Required Field")),
    parentelementid: Yup.string().required(t("Required Field")),
    periodlevelid: Yup.string().required(t("Required Field")),
    valuesettingid: Yup.string().required(t("Required Field")),
  });
};

export const KPI_EMPTY_INITIAL_VALUES: KPIValues = {
  basicInformation: {},
  parentelementid: "",
  measureunitid: "",
  periodlevelid: "",
  valuesettingid: "",
  location: {
    topelementid: "",
    themesymbol: "",
    prioritysymbol: "",
  },
  values: [],
};
